<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de prácticas</h4>
        <button type="button" class="btn btn-primary" routerLink="/addpractice">Crear nueva práctica</button>
        <button (click)="habilitarPracticasMasivo()" type="button" class="btn btn-warning btn-sm ms-2">Habilitar Todas</button>
        <button (click)="deshabilitarPracticasMasivo()" type="button" class="btn btn-danger btn-sm ms-2">Inhabilitar Todas</button>
    </div>

    <table *ngIf="listPractices.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Gestión</th>
            <th scope="col">Carrera</th>
            <th scope="col">Centro</th>
            <th scope="col">Area</th>    
            <th scope="col">Turno</th>
            <th scope="col">Vacantes</th>
            <th scope="col">Inscritos</th>
            <th scope="col">Estado</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listPractices" class="table-active">
            <td>{{ item.namemanagement }}</td>
            <td>{{ item.namecareer }}</td>
            <td>{{ item.namecenter }}</td>
            <td>{{ item.namearea }}</td>
            <td>{{ item.nameturn }}</td>
            <td>{{ item.quota }}</td>
            <td>{{ item.enrolled }}</td>
            <td>{{ item.state === 1 ? 'Habilitado' : 'Deshabilitado' }}</td>
            <td>
              <button (click)="updatePracticeState(item.id!, item.state)" type="button" class="btn btn-warning btn-sm">Cambiar estado</button>
              <button routerLink="/editpractice/{{item.id}}" type="button" class="btn btn-info btn-sm ms-2">Edit</button>
              <button (click)="deletePractice(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listPractices.length == 0">No hay prácticas para mostrar</h5>
</div>